function Registry() {
  return (
    <main className="page-panel page-event px-4 py-8">
      <div className="max-w-3xl mx-auto">
        <h1 className="text-2xl font-semibold mb-4">Registry</h1>

        <section className="info-window rounded-lg p-6 mb-6">
          <div className="readable-font" style={{ color: 'var(--forest)' }}>
            <p>We are registered with Zola at the following link</p>
            <p className="mt-3">
              <a
                href="https://www.zola.com/registry/jackandkaterina2026/"
                className="underline hover:no-underline"
                target="_blank"
                rel="noreferrer"
              >
                Zola Registry →
              </a>
            </p>
          </div>
        </section>
      </div>
    </main>
  );
}

export default Registry;
